
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h24v24H0z","stroke":"transparent","fill":"none"}}),_c('path',{attrs:{"d":"M18.322 6.709l-.016-.016a2.378 2.378 0 00-3.361.005l-7.868 7.869a.4.4 0 00-.082.121l-.008.02c0 .011-.013.034-.016.045l-.959 3.74a.407.407 0 00.394.507.43.43 0 00.1-.012l3.742-.96a.446.446 0 00.06-.023.391.391 0 00.125-.083l7.851-7.852a2.378 2.378 0 00.038-3.363zM6.971 18.035l.611-2.386 1.778 1.774zm3.178-.972l-2.209-2.2 6.636-6.636 2.207 2.207zm7.627-7.628l-.41.414-2.205-2.206.41-.413a1.557 1.557 0 011.055-.41 1.554 1.554 0 011.1.455l.011.011a1.567 1.567 0 01.039 2.144z"}})])
          )
        }
      }
    